import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

/**
 * A screen or a region with nothing to show (yet): what it is, why it is empty, and the next step
 * when there is one. Never a fake working screen.
 */
export function EmptyState({
  icon,
  title,
  children,
  action,
}: {
  readonly icon: IconName;
  readonly title: string;
  readonly children?: ReactNode;
  readonly action?: ReactNode;
}) {
  return (
    <section className="empty-state" aria-label={title}>
      <span className="empty-state__icon" aria-hidden="true">
        <Icon name={icon} />
      </span>
      <h2 className="empty-state__title">{title}</h2>
      {children !== undefined && <div className="empty-state__text">{children}</div>}
      {action !== undefined && <div className="empty-state__action">{action}</div>}
    </section>
  );
}
